// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B2) — appels et messages inchangés.
import { useState } from "react";
import api from "@/api";
import { toast } from "sonner";

export default function usePatientDocuments(patientId, onChanged) {
  const [uploading, setUploading] = useState(false);

  const handleFileUpload = async (e, docType = "medical_report") => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("doc_type", docType);

    setUploading(true);
    try {
      const { data } = await api.post(`/patients/${patientId}/documents`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (data?.warning) {
        toast.warning(data.warning, { duration: 8000 });
      } else {
        toast.success("Document uploadé");
      }
      onChanged();
    } catch {
      toast.error("Erreur lors de l'upload");
    } finally {
      setUploading(false);
    }
  };

  const handleDownload = async (docId, fileName) => {
    try {
      const response = await api.get(`/documents/${docId}/download`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      toast.error("Erreur téléchargement");
    }
  };

  const handleDeleteDoc = async (docId) => {
    if (!confirm("Supprimer ce document ?")) return;
    try {
      await api.delete(`/documents/${docId}`);
      toast.success("Document supprimé");
      onChanged();
    } catch {
      toast.error("Erreur");
    }
  };

  return { uploading, handleFileUpload, handleDownload, handleDeleteDoc };
}
